import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";

export default function PrivacyPolicy() {
  return (
    <>
      <Seo title="Privacy Policy — SENIORCAR" noindex
        description="Informativa sul trattamento dei dati personali di SENIORCAR (FM FACTORY srl) ai sensi del Regolamento UE 2016/679 (GDPR)." />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Privacy Policy" }]} /></div>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 pt-6 pb-16 sc-prose" data-testid="privacy-page">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900" style={{ fontFamily: "Outfit" }}>Informativa sulla privacy</h1>
        <p className="text-sm text-slate-500 mt-2">Ultimo aggiornamento: giugno 2026</p>
        <p>La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che consultano
          questo sito e utilizzano i relativi servizi (moduli di contatto, richiesta informazioni e prenotazione prova),
          ai sensi del Regolamento (UE) 2016/679 (“GDPR”) e della normativa italiana applicabile.</p>

        <h2>1. Titolare del trattamento</h2>
        <p><strong>FM FACTORY srl</strong> (brand “SENIORCAR”) — via Isaac Newton 9 - 20016 Pero Milano - VAT 11919330966<br />
          Sede: Via Isaac Newton 9, 20016 Pero (Milano)<br />
          Email: <a href="mailto:info@seniorcar.it">info@seniorcar.it</a> — Telefono: 02 80 89 77 41</p>

        <h2>2. Categorie di dati trattati</h2>
        <ul>
          <li><strong>Dati di contatto e anagrafici</strong> che ci fornisci volontariamente tramite i moduli: nome, cognome, telefono, email, provincia/città ed eventuali note.</li>
          <li><strong>Dati relativi alla richiesta</strong>: tipologia di esigenza, preferenze per la prova, pagina di provenienza.</li>
          <li><strong>Dati di navigazione</strong>: raccolti tramite cookie e tecnologie simili solo previo consenso (vedi <Link to="/cookie">Cookie Policy</Link>).</li>
        </ul>
        <p>Non ti chiediamo di comunicare dati relativi alla salute. Ti invitiamo a non inserire dati particolari (art. 9 GDPR) nel campo note; qualora lo facessi, il trattamento avverrà sulla base del consenso da te prestato con l’invio.</p>

        <h2>3. Finalità e basi giuridiche</h2>
        <ul>
          <li><strong>Rispondere alle richieste e organizzare la prova del prodotto</strong> — base giuridica: esecuzione di misure precontrattuali e riscontro alla tua richiesta (art. 6.1.b GDPR).</li>
          <li><strong>Gestione della relazione e assistenza</strong> — legittimo interesse del titolare (art. 6.1.f GDPR).</li>
          <li><strong>Cookie di analisi e marketing</strong> — consenso (art. 6.1.a GDPR), revocabile in ogni momento.</li>
          <li><strong>Adempimenti di legge</strong> — obbligo legale (art. 6.1.c GDPR).</li>
        </ul>

        <h2>4. Destinatari dei dati</h2>
        <p>I dati possono essere trattati da personale autorizzato e comunicati a: la rete dei rivenditori/centri SENIORCAR
          competenti per territorio (per organizzare la prova o la consulenza), fornitori di servizi IT e di hosting, e il
          fornitore di servizi email per l’invio delle comunicazioni. Tali soggetti operano quali responsabili del
          trattamento o titolari autonomi, nel rispetto della normativa.</p>

        <h2>5. Trasferimenti extra-UE</h2>
        <p>Qualora alcuni fornitori trattino dati al di fuori dello Spazio Economico Europeo, il trasferimento avviene nel
          rispetto delle garanzie previste dal GDPR (es. clausole contrattuali standard della Commissione europea).</p>

        <h2>6. Periodo di conservazione</h2>
        <p>I dati sono conservati per il tempo necessario a gestire la tua richiesta e la relazione commerciale e,
          successivamente, per il tempo previsto da obblighi di legge. I dati raccolti tramite cookie sono conservati per
          le durate indicate nella <Link to="/cookie">Cookie Policy</Link>.</p>

        <h2>7. I tuoi diritti</h2>
        <p>Hai diritto di accedere ai tuoi dati, chiederne la rettifica o la cancellazione, la limitazione o l’opposizione
          al trattamento, la portabilità, e di revocare il consenso in qualsiasi momento (senza pregiudicare la liceità del
          trattamento precedente). Puoi esercitare i tuoi diritti scrivendo a
          <a href="mailto:info@seniorcar.it"> info@seniorcar.it</a>. Hai inoltre diritto di proporre reclamo al Garante per
          la protezione dei dati personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer">www.garanteprivacy.it</a>).</p>

        <h2>8. Cookie</h2>
        <p>Questo sito utilizza cookie tecnici necessari e, previo consenso, cookie di analisi e marketing. Puoi gestire le
          tue preferenze in qualsiasi momento dal banner o dal link “Preferenze cookie” presente nel footer. Dettagli nella
          <Link to="/cookie"> Cookie Policy</Link>.</p>

        <h2>9. Modifiche</h2>
        <p>Il titolare può aggiornare la presente informativa. Le modifiche saranno pubblicate su questa pagina con
          indicazione della data di ultimo aggiornamento.</p>
      </article>
    </>
  );
}
